/**
 * Indique si l'URL pointe vers un fichier SVG (hors query string SAS).
 * @param {string} src - URL ou chemin de l'image.
 * @returns {boolean} `true` si l'extension est `.svg`.
 */
export function isSvgImageSrc(src: string): boolean {
  const pathWithoutQuery: string = src.split('?')[0]?.toLowerCase() ?? ''
  return pathWithoutQuery.endsWith('.svg')
}

/**
 * Les images distantes (blob Azure + SAS) ne passent pas par IPX : le `/` dans `sig` casse `/_ipx/...`.
 * On garde Nuxt Image uniquement pour les assets locaux `/public`.
 * @param {string} src - URL ou chemin de l'image.
 * @returns {boolean} `true` si la source commence par `http://` ou `https://`.
 */
export function isRemoteImageSrc(src: string): boolean {
  const trimmed: string = src.trim()
  if (!trimmed || trimmed.startsWith('/')) return false
  return /^https?:\/\//i.test(trimmed)
}

/**
 * Format Nuxt Image adapté à la source (préserve les SVG, WebP pour le reste).
 * @param {string} src - URL ou chemin de l'image affichée.
 * @returns {'svg' | 'webp'} Format IPX à appliquer.
 */
export function getNuxtImageFormatForSrc(src: string): 'svg' | 'webp' {
  if (isSvgImageSrc(src)) return 'svg'
  return 'webp'
}
